import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";

import Typography from "@mui/material/Typography";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import AssignmentIcon from "@mui/icons-material/Assignment";

import Button from "../../components/Button";
import TableComponent from "../../components/TableComponent";
import { getUsersAssessment } from "../../api/training.deprecated";
import useCrew from "../../hooks/useCrew";

const AssessmentTraining = ({ match, history }) => {
  const { t } = useTranslation();
  const trainingId = match.params.trainingId;
  const { crew } = useCrew();

  const [usersInscribed, setUsersInscribed] = useState([]);

  useEffect(() => {
    (async () => {
      const usersInscribed = await getUsersAssessment(trainingId, crew.id, crew.baseIds);
      setUsersInscribed(usersInscribed);
    })();
  }, [trainingId, crew]);

  return (
    <>
      <Typography variant="h4">{t("training_pages.assessment_list_users")}</Typography>
      {usersInscribed && (
        <TableComponent
          header={[
            { title: t("training_pages.user_id"), style: { width: "5%" } },
            { title: t("user") },
            { title: t("training_pages.crew") },
            { title: t("position.name") },
            { title: t("actions") },
          ]}
          renderChildren={(userInscribed, index) => (
            <TableRow key={index}>
              <TableCell>{userInscribed.id}</TableCell>
              <TableCell>{userInscribed.fullname}</TableCell>
              <TableCell>{userInscribed.companyName}</TableCell>
              <TableCell>{userInscribed.positionName}</TableCell>
              <TableCell>
                {userInscribed.positionId && (
                  <Button
                    icon={<AssignmentIcon />}
                    onClick={() =>
                      history.push(`/training-users/user/assessment/${userInscribed.id}/${userInscribed.positionId}`)
                    }
                    title={t("training_pages.take_assessment")}
                  />
                )}
              </TableCell>
            </TableRow>
          )}
          search={["user_id", "fullname", "companyName"]}
          pagination
          items={usersInscribed}
        />
      )}
      <Button title={t("back")} onClick={() => history.goBack()}>
        {t("back")}
      </Button>
    </>
  );
};

export default AssessmentTraining;
